import { jsx as _jsx } from "react/jsx-runtime";
import { CardContent, Typography } from '@mui/material';
export function ErrorScreen(props) {
    return (_jsx(CardContent, { sx: { width: '100%' }, children: props.textLines.map((textLine, index) => (_jsx(Typography, { variant: "body1", sx: { color: 'error.light' }, children: textLine }, `error-text-line-${index}`))) }));
}
//# sourceMappingURL=ErrorScreen.js.map